export function updateSystemVariableMap(state, { key, value }) {
  state.systemVariableMap[key] = value;
}

export function setSystemVariableList(state, { list, variableMap }) {
  state.systemVariableList = list;
  state.systemVariableMap = variableMap;
}
